import React from "react";
import { LogRenderContext } from "../LogRenderer";
import Deleted from "../common/Deleted";
import { getTargetGroupDetails } from "../utils";

const TargetGroupDeleted = () => {
  const { log } = React.useContext(LogRenderContext);
  const { name, id, updatedBy, updatedAt } = getTargetGroupDetails(log);
  return <Deleted name={name} id={id} updatedBy={updatedBy} updatedAt={updatedAt} />;
};

export default TargetGroupDeleted;
